import React from "react";
import { useStateValue } from "./StateProvider";
//import Player from "./Player";
import "./SkinsDetail.css";

function SkinsDetail() {
  const [{ players }] = useStateValue();
  const [{ skins }] = useStateValue();
  //const [{ hole }] = useStateValue();
  const [{ dogmeat }] = useStateValue();


  const getSkinsF9 = () => {
    const skinHoles = skins.filter((s) => s.Hole <= 9);
    skinHoles.sort((a, b) => {
      return a.Hole - b.Hole;
    });
    //console.log(skinHoles)
    return skinHoles;
  };
  const getSkinsB9 = () => {
    const skinHoles = skins.filter((s) => s.Hole >= 10);
    skinHoles.sort((a, b) => {
      return a.Hole - b.Hole;
    });
    return skinHoles;
  };

  const getInitial = (id) => {
    const winner = players.find((s) => s.id === id);
    if (winner)
    return winner.abb ? winner.abb : winner.first[0]; //get first inital
  };

  const getTotalSkins = () => {
    const Total = skins?.reduce(
      (totalSkins, score) => totalSkins + score.Amount,
      0
    );
    return Total;
  };
  const getTotalDM = () => {
    const Total = dogmeat.length
 
    return Total;
  };

  return (
    < div className="skins__dogmeat">
      <div className="skin__details">
           {/* show front skins if any exist */}
      {(skins.filter((s) =>s.Hole <= 9)).length > 0 ? (
      
      <div className="scoregrid">
        {getSkinsF9().map((score, i) => (
          <div key={i} className="holescores">
            <div className="holelabel">{score.Amount}</div>
            <div className="skinswinner">
              {score.Winner === "Carry Over" ? "" : getInitial(score.Winner)}
            </div>
          </div>
        ))}
        </div>

        ):""}
      
      {/* show back skins if any exist */}
      { (skins.filter((s) =>s.Hole >=10)).length>0?(
        <div className="scoregrid">
          {getSkinsB9().map((score, i) => (
            <div key={i} className="holescores">
              <div className="holelabel">{score.Amount}</div>
              <div className="skinswinner">
                {score.Winner === "Carry Over" ? "" : getInitial(score.Winner)}
              </div>
            </div>
          ))}
        </div>) : ("")}
      </div>
    

      <div className="dogmeat__holes">
            {dogmeat.map((s,i)=>(
              <div key={i} className="dogmeatholes__detail">
                 <div className="dmhole"> {s.hole}</div>
                 <div className="dmwinner">{getInitial(s.id)}</div>
              </div>
             ) )}          
      </div>


      <div className="summary__totals">
        <div className="TotalSkins">Skins-{getTotalSkins()}</div>
        <div className="TotalDM">Dog Meat-{getTotalDM()}</div>
      </div>
    </div>
  );
}

export default SkinsDetail;
